module.exports = __webpack_public_path__ + "static/img/3.9e853b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/sp/3.png
// module id = A0uk
// module chunks = 0